/* eslint-disable */

import React from 'react'
import { createScope, map, transformProxies } from './helpers'

const scripts = [

]

let Controller

class MobileFooterView extends React.Component {
  static get Controller() {
    if (Controller) return Controller

    try {
      Controller = require('../controllers/MobileFooterController')
      Controller = Controller.default || Controller

      return Controller
    }
    catch (e) {
      if (e.code == 'MODULE_NOT_FOUND') {
        Controller = MobileFooterView

        return Controller
      }

      throw e
    }
  }

  componentDidMount() {
    /* View has no WebFlow data attributes */

    scripts.concat(null).reduce((active, next) => Promise.resolve(active).then((active) => {
      const loading = active.loading.then((script) => {
        new Function(`
          with (this) {
            eval(arguments[0])
          }
        `).call(window, script)

        return next
      })

      return active.isAsync ? next : loading
    }))
  }

  render() {
    const proxies = MobileFooterView.Controller !== MobileFooterView ? transformProxies(this.props.children) : {
      'logo-button': [],
      'phone-link': [],
      'email-link': [],
      'pm-link': [],
      'folio-link': [],
      'shop-link': [],
      'quote-link': [],
      'contact-link': [],
      'help-link': [],
      'social-link': [],
    }

    return (
      <span>
        <style dangerouslySetInnerHTML={{ __html: `
          @import url(/css/normalize.css);
          @import url(/css/webflow.css);
          @import url(/css/pss-testing.webflow.css);
        ` }} />
        <span className="af-view">
          <div className="af-class-div-block-78">
            <div className="af-class-columns-10 w-row">
              <div className="af-class-column-99 w-col w-col-8 w-col-tiny-tiny-stack">
                <div className="af-class-footer-logo-block">
                  {map(proxies['logo-button'], props => <a data-ix="logo" href="#" {...{...props, className: `af-class-footer-logo w-nav-brand ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment><img src="images/NEW-pss-logo.svg" width={103} alt="PSS Logo" /></React.Fragment>}</a>)}
                  <p className="af-class-p6">PSS exists to support educators with amazing communication tools to help you achieve your education goals.<br /></p>
                  {map(proxies['phone-link'], props => <div {...{...props, className: `af-class-h10 ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>1-800-485-9722</React.Fragment>}</div>)}
                  {map(proxies['email-link'], props => <div {...{...props, className: `af-class-h10 ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>info@pssk12.com</React.Fragment>}</div>)}
                </div>
              </div>
              <div className="af-class-column-103 w-col w-col-4 w-col-tiny-tiny-stack">
                <h5 className="af-class-footer-header">Learn more</h5>
                {map(proxies['pm-link'], props => <a href="#" {...{...props, className: `af-class-footer-link ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Poster Maker</React.Fragment>}</a>)}
                {map(proxies['folio-link'], props => <a href="#" {...{...props, className: `af-class-footer-link ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Folio</React.Fragment>}</a>)}
                {map(proxies['shop-link'], props => <a href="#" {...{...props, className: `af-class-footer-link ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Shop for Supplies</React.Fragment>}</a>)}
                {map(proxies['quote-link'], props => <a href="#" {...{...props, className: `af-class-footer-link ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Get a Quote</React.Fragment>}</a>)}
                {map(proxies['contact-link'], props => <a href="#" {...{...props, className: `af-class-footer-link ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Contact Us</React.Fragment>}</a>)}
                {map(proxies['help-link'], props => <a href="#" {...{...props, className: `af-class-footer-link ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Product Help</React.Fragment>}</a>)}
                {map(proxies['social-link'], props => <a href="#" {...{...props, className: `af-class-footer-link ${props.className || ''}`}}>{props.children ? props.children : <React.Fragment>Follow us on Social Media!</React.Fragment>}</a>)}
              </div>
            </div>
          </div>
        </span>
      </span>
    )
  }
}

export default MobileFooterView